// extracted by mini-css-extract-plugin
module.exports = {"content":"modalforget_content__3ySjn","label_forget":"modalforget_label_forget__3VWmL","form_forget":"modalforget_form_forget__KpvPo"};